"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SEGMENT = exports.NO_DATA = exports.WALK_IN_CUSTOMER = exports.ADJUSTMENTS_DATE_RANGE_FILTER = exports.DEFAULT_DATE_RANGE_FILTER = exports.DEFAULT_TIME_ZONE = void 0;
const reporting_1 = require("../enums/reporting");
exports.DEFAULT_TIME_ZONE = 'Australia/Melbourne';
exports.DEFAULT_DATE_RANGE_FILTER = {
    key: 'Orders.updatedAt',
    text: 'backOfficeSalesFeed.DateTime',
    type: reporting_1.DateRangeFilterType.FILTER_BY_PRESET,
    value: reporting_1.DateRangeFilterPresets.TODAY,
};
exports.ADJUSTMENTS_DATE_RANGE_FILTER = {
    key: 'OrderAdjustments.createdAt',
    text: 'backOfficeSalesFeed.DateTime',
    type: reporting_1.DateRangeFilterType.FILTER_BY_PRESET,
    value: reporting_1.DateRangeFilterPresets.TODAY,
};
exports.WALK_IN_CUSTOMER = 'Walk-in';
exports.NO_DATA = 'N/A';
exports.DEFAULT_SEGMENT = reporting_1.ReportSegment.NON_VOIDED_ORDERS;
//# sourceMappingURL=reporting.js.map